import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomFieldsModule } from '@freelancer/custom-fields';
import { UiModule } from '@freelancer/ui/ui.module';
import { UserProfilePractitionerInformationItemComponent } from './user-profile-practitioner-information-item/user-profile-practitioner-information-item.component';
import { UserProfilePractitionerInformationComponent } from './user-profile-practitioner-information.component';

@NgModule({
  imports: [UiModule, CommonModule, CustomFieldsModule],
  declarations: [
    UserProfilePractitionerInformationComponent,
    UserProfilePractitionerInformationItemComponent,
  ],
  exports: [UserProfilePractitionerInformationComponent],
})
export class UserProfilePractitionerInformationModule {}
